import React from 'react'

function Map() {
  return (
    <div className="map">
      <h1>I am a map.</h1>
    </div>
  )
}

export default Map

